<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Librería HOE</h1>
</div>

<!--&================== DIVIDER BUTONS LIBRARY ==================&-->
<div class="divider-butons">
  <div routerLink="/Dashboard/CCP/SeeAllTasksLibCCP" class="btn btn-icon-text-left">
    <span class="text">Tareas</span><i class="fa-regular fa-bell"></i>
    <span class="number-circle">{{Total_Task()}}</span>
  </div>
</div>

<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div class="container-global-components ConFLCCP">

  <!---================= CONTAINER FOR SHOW ROUTE =================--->
  <div class="Show-Route"><i class="fas fa-folder"></i><i class="fas fa-angle-right"></i>
    <div (click)="SeeFolder_BreadCrum(i)" class="Route-Generator" *ngFor="let ruta of Header_Routes; let i=index">
      <span>{{ruta.split('§').pop()}}</span> <i class="fas fa-angle-right"></i>
    </div>
  </div>

  <!---================= SHOW CREATE CARPET OR HOE AND SEE ALL DIRECTORIES AND CCPS =================--->
  <div class="SectionCreateTotal">
    <div class="left-CT">
      <div (click)="ToggleModalAddCCP(true)"
        *ngIf="(UserRoleIn([PermissionCCP.createFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])) && !Enable_BtnNewCCP() && LoadPage"
        class="btnCreateCCP btn-icon-text">
        <i class="fa-solid fa-plus"></i><span class="text">Nueva HOE</span>
      </div>
      <div (click)="ToggleModalAddFolderCCP(true)" *ngIf="(UserRoleIn([PermissionCCP.createFolder]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP]))"
        class="btnCreateDir btn-icon-text">
        <i class="fa-solid fa-folder-plus"></i><span class="text">Crear Carpeta</span>
      </div>
    </div>
    <div class="right-CT">
      <div class="AllDirectories">Total de Carpetas: <b>{{this.TotalFoldersC}}</b> <i class="fas fa-folder"></i></div>
      <div class="AllFiles">Total de Archivos: <b>{{this.TotalFilesCCP}}</b> <i class="fas fa-file"></i></div>
    </div>
  </div>


  <!---================= CONTAINER FOR TABLE LIBRARY =================--->
  <div class="Table-Lib Table-container-Global">

    <p-table #dtCCP [value]="All_FAF_CCP" [(selection)]="SelectedALL_FAF_CCP" dataKey="id" [rowHover]="true" [rows]="10"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Extension','Name','Key_Word','Revision_No','Code','Invoice_4M']">


      <ng-template pTemplate="caption">
        <!---================= SEARCH AND BACK BUTTON =================--->
        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">
            <div class="search inputText" *ngIf="Show_InputSearch()">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="CCP_Filter" type="text"
                (input)="dtCCP.filterGlobal(CCP_Filter, 'contains')" placeholder="Buscar en libreria HOE" />
            </div>
          </div>
          <div class="right-CT">
            <div *ngIf="Header_Routes.length>1" class="btnBack btn-icon" (click)="GoBackFolder()">
              <i class="fa-solid fa-angles-left"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">

        <tr>
          <th *ngIf="isMobileDevice">Opciones</th>
          <th>Actualizar</th>

          <ng-container *ngFor="let Table_header of CCP_Table_Headers;let i=index">

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_CCP.IDC">
              <th pSortableColumn="ID" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="ID"></p-sortIcon>
                    <p-columnFilter type="text" field="ID" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === Key_Header_CCP.EXT">
              <th pSortableColumn="Extension" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Extension"></p-sortIcon>
                    <p-columnFilter field="Extension" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Tipo documento</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="this.Filter_Global_Check.Extension"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <ng-container *ngIf="option==='dir'">
                              <div class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/Folder.png" alt="" srcset="">
                                  <span>Carpeta</span>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngFor="let icon of Icons_Image">
                              <div *ngIf="option.toUpperCase()==icon.Extension.toUpperCase()" class="Icon-Table-File">
                                <div class="Content-Icon">
                                  <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                                  <span>{{icon.Name}}</span>
                                </div>
                              </div>
                            </ng-container>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.NAM">
              <th pSortableColumn="Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.KEW">
              <th pSortableColumn="Key_Word" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Key_Word"></p-sortIcon>
                    <p-columnFilter type="text" field="Key_Word" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.NOR">
              <th pSortableColumn="Revision_No" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter type="text" field="Revision_No" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.YEM">
              <th pSortableColumn="Model_Year" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Model_Year"></p-sortIcon>
                    <p-columnFilter field="Model_Year" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Tipo documento</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Model_Year"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>


                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.COD">
              <th pSortableColumn="Code" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Code"></p-sortIcon>
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.INV">
              <th pSortableColumn="Invoice_4M" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Invoice_4M"></p-sortIcon>
                    <p-columnFilter type="text" field="Invoice_4M" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.REV">
              <th pSortableColumn="Reviewer_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Reviewer_Name"></p-sortIcon>
                    <p-columnFilter field="Reviewer_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Reviewer_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.APR">
              <th pSortableColumn="Approver_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Name"></p-sortIcon>
                    <p-columnFilter field="Approver_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.MOB">
              <th pSortableColumn="Contributor_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Contributor_Name"></p-sortIcon>
                    <p-columnFilter field="Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.DAM">
              <th pSortableColumn="Date_Modification" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Modification"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Modification" display="menu"
                      class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.DAC">
              <th pSortableColumn="Date_Created" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Created"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.DAE">
              <th pSortableColumn="Date_Expiration" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Expiration"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Expiration" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.STA">
              <th pSortableColumn="Status" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Status" placeholder="Seleccione"
                          (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option">
                                    <div *ngSwitchCase='1'>Aprobada</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazada</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.CON">
              <th pSortableColumn="Contributor_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Contributor_Name"></p-sortIcon>
                    <p-columnFilter field="Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.ARE">
              <th pSortableColumn="Area_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Area_Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Area_Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header===Key_Header_CCP.SHO">
              <th pSortableColumn="Shop_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Shop_Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Shop_Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

          </ng-container>

        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-All_FAF_CCP>

        <tr (contextmenu)="RightClick_Context_Menu($event,All_FAF_CCP)">

          <td>
            <div *ngIf="isMobileDevice" class="Update" (click)="RightClick_Context_Menu($event, All_FAF_CCP, true)">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div (click)="Can_Upgrade(All_FAF_CCP)"
              *ngIf="(UserRoleIn([PermissionCCP.updateFile]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])) && !All_FAF_CCP.Directory"
              class="Update">
              <i class="fa-solid fa-file-pen"></i>
            </div>
          </td>

          <td *ngFor="let Header of CCP_Table_Headers">

            <ng-container *ngIf="Header.Key_Header === Key_Header_CCP.IDC">
              {{All_FAF_CCP.ID}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === Key_Header_CCP.EXT">
              <div (click)="SeeFolder(All_FAF_CCP)" *ngIf="All_FAF_CCP.Directory" class="Folder-Table">
                <div class="Folder_back">
                  <div class="Paper"></div>
                  <div class="Paper"></div>
                  <div class="Paper"></div>
                  <div class="Folder_front"></div>
                  <div class="Folder_front right"></div>
                </div>
              </div>

              <ng-container *ngFor="let icon of Icons_Image">

                <div (click)="PreviewFile(All_FAF_CCP)" *ngIf="All_FAF_CCP.Extension.toUpperCase()==icon.Extension.toUpperCase()"
                  class="Icon-Table-File">
                  <div class="Content-Icon">
                    <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                    <div class="ToolTip-Download">Vista Previa</div>
                  </div>
                </div>

              </ng-container>

            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.NAM">
              <div (click)="SeeFolder(All_FAF_CCP)" *ngIf="All_FAF_CCP.Directory" class="dragstar" draggable="true">
                {{All_FAF_CCP.Name}}
              </div>
              <div *ngIf="All_FAF_CCP.Directory!=true" class="Container-Name-in-table dragstar clickable-name" draggable="true" (click)="PreviewFile(All_FAF_CCP, $event)">
                <div *ngIf="Is_New_CCP_In_System(All_FAF_CCP.Date_Created)" class="Date-marker"><i
                    class="fa-brands fa-slack"></i></div> {{All_FAF_CCP.Name}}
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.KEW">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Key_Word}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.NOR">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Revision_No}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.YEM">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Model_Year===0?'N/A':All_FAF_CCP.Model_Year}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.COD">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Code}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.INV">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Invoice_4M}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.REV">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Reviewer_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.APR">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Approver_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.MOB">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Contributor_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.DAM">
              <div *ngIf="!All_FAF_CCP.Directory">{{Get_Date_Modification(All_FAF_CCP.Date_Modification)}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.DAC">
              <div *ngIf="!All_FAF_CCP.Directory">{{Get_Date_Created(All_FAF_CCP.Date_Created)}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.DAE">
              <div *ngIf="All_FAF_CCP.Directory!=true" class="Container-Expired">
                {{Get_Date_Expiration(All_FAF_CCP.Date_Expiration)}}
                <div class="Date-Expired {{Expiry_Status(All_FAF_CCP.Date_Expiration)}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.STA">
              <div *ngIf="!All_FAF_CCP.Directory">{{Status_string(All_FAF_CCP.Status)}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.CON">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Contributor_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.ARE">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Area_Name}}</div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header===Key_Header_CCP.SHO">
              <div *ngIf="!All_FAF_CCP.Directory">{{All_FAF_CCP.Shop_Name}}</div>
            </ng-container>
          </td>

        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="All_FAF_CCP.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr class="Not-Files-tr">
          <div class="Not-Files" *ngIf="All_FAF_CCP.length===0 && LoadPage">
            <div class="Img-Not">
              <img src="./assets/Global/Ilustrations/Not-Files.png" alt="">
            </div>
            <div class="Text-Not-Files">
              El directorio está vacío, no tiene procesos o carpetas.
            </div>
          </div>
        </tr>
      </ng-template>

    </p-table>


  </div>



</div>

<!--&================== CONTAINER FOR ESTATUS HOE ==================&-->
<div (click)="See_CCP_Contributions()" *ngIf="Header_Routes.length==1" class="Section-Status title-components">
  <h1>Estatus HOE</h1>
  <div class="Container-Status container-global-components">
    <div class="Description-Status">
      Consulte el estatus de cada una de las HOE contribuidas.
    </div>
    <div class="btnStatus">
      <div class="btn-icon-text-left-outlined">
        <span class="text">Ver Estatus HOE</span><i class="fa-brands fa-stack-overflow"></i>
      </div>
    </div>
  </div>
</div>


<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR ADD NEW FOLDER =====================--->
<section class="Modal-Global" id="ModalAddFolderCCP">
  <div class="wrapper">
    <div class="Pro-popup3 popup">
      <div class="Pro-inside3 popup-inside">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormAddFolderCCP" (ngSubmit)="AddFolder()">
        <div class="Pro-content3 content">
          <div class="Btn-Close" (click)="ToggleModalAddFolderCCP(false)"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Crear carpeta</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input Input-Text-Form" id="IdInputCodeNewCCP">
                <i class="fa-solid fa-signature"></i><input type="text" formControlName="NameFolderCCP">
              </div>
            </div>

            <!-- Sección de Configuración Avanzada -->
            <div class="Advanced-Config-Toggle" (click)="ShowAdvancedConfig = !ShowAdvancedConfig">
              <i class="fa-solid" [ngClass]="ShowAdvancedConfig ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              <span>Configuración Avanzada de Flujo</span>
            </div>

            <div class="Advanced-Config-Content" *ngIf="ShowAdvancedConfig">
              <div class="OCR-Config-Section">
                <div class="OCR-Config-Header">
                  <i class="fa-solid fa-magnifying-glass-location"></i>
                  <h6>Extracción OCR por RegEx</h6>
                </div>
                <div class="Container-input Input-Text-Form">
                  <i class="fa-solid fa-code"></i>
                  <input type="text" formControlName="OCR_Regex" placeholder="Ej: FOL-(\d+)  |  Dejar vacío para usar los patrones por defecto">
                </div>
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-check-double"></i><span class="text">Crear carpeta</span>
            </button>
            <div (click)="ToggleModalAddFolderCCP(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR ADD NEW HOE =====================--->
<section class="Modal-Global" id="ModalAddCCP">
  <div class="wrapper">
    <div class="Pro-popupCCP1 popup">
      <div class="Pro-insideCCP1 popup-inside">
        <div class="Pro-backgroundsCCP1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormCCP" (ngSubmit)="ValidToogleCCP()">
        <div class="Pro-contentCCP1 content">
          <button type="button" id="Btn-Close-Add-Top" class="Btn-Close" (click)="ToggleModalAddCCP(false)"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Agregar nueva HOE</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input InputFile" id="IdInputFileNewCCP">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivo</div><input #AddFileCCP (change)="AddDocument($event)"
                    type="file" name="">
                </div>
                <div class="Name-File">
                  {{CutNameFile(this.FileAuxAddCCP.FileName)}}
                </div>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                OCR Local
              </div>
              <div class="Container-input-switch">
                <div class="switch-container" [class.active]="UseOCR_Local" (click)="ToggleOCR_Local()">
                  <div class="switch-label">
                    <i [class]="UseOCR_Local ? 'fa-solid fa-server' : 'fa-solid fa-circle-exclamation'"></i>
                    <span>{{ UseOCR_Local ? 'Local Activo' : 'Local Desactivado' }}</span>
                  </div>
                  <div class="switch-button">
                    <div class="handle"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                OCR Cloud
              </div>
              <div class="Container-input-switch">
                <div class="switch-container" [class.active]="UseOCR_Cloud" (click)="ToggleOCR_Cloud()">
                  <div class="switch-label">
                    <i [class]="UseOCR_Cloud ? 'fa-solid fa-cloud' : 'fa-solid fa-circle-exclamation'"></i>
                    <span>{{ UseOCR_Cloud ? 'Cloud Activo' : 'Cloud Desactivado' }}</span>
                  </div>
                  <div class="switch-button">
                    <div class="handle"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="Content-grid-2">
              <div class="Text-icon">
                Key Word
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-keycdn"></i><input id="IdInputKeyWNewCCP" type="text" formControlName="KeyWord"
                  placeholder="Key Word HOE..." [class.Is-Disabled]="NameFileCCP.invalid"
                  [appFormCcpDisabled]="NameFileCCP.invalid">
              </div>
            </div> -->

            <div class="Content-grid-2">
              <div class="Text-icon">
                Model Year
              </div>
              <div class="Container-input Inputng-Select">
                <i class="fa-regular fa-circle-question"></i>
                <ng-select id="IdInputSeleNewCCP" class="Custom-Form" [searchable]="false" [items]="OptionsModelYear"
                  formControlName="Model_Year" [appFormCcpDisabled]="NameFileCCP.invalid"
                  [class.Is-Disabled]="NameFileCCP.invalid" bindLabel="item" autofocus bindValue="value">
                </ng-select>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Shop
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputShopNewCCP" formControlName="Shop" [appFormCcpDisabled]="NameFileCCP.invalid"
                  [(ngModel)]="ShopSelected" [class.Is-Disabled]="NameFileCCP.invalid" [options]="Shops"
                  optionLabel="Name" placeholder="Seleccione una shop…"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Area
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputAreaNewCCP" formControlName="Area" [appFormCcpDisabled]="NameFileCCP.invalid"
                  [class.Is-Disabled]="NameFileCCP.invalid"
                  [options]="ShopSelected!?ShopSelected.Area:[]" optionLabel="Name"
                  placeholder="{{ShopSelected!?'Seleccione una Area':'Seleccione primero una shop'}}"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Revisor
              </div>
              <div class="Container-input Input-Autocomplete">
                <i class="fa-regular fa-user"></i>
                <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="ListOfUsersReviewers"
                  id="IdInputAuReNewCCP" [initialValue]="" placeholder="Buscar usuario revisor" searchKeyword="Name"
                  notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateReviewers"
                  [notFoundTemplate]="notFoundReviewers" formControlName="Reviwer"
                  [appFormCcpDisabled]="NameFileCCP.invalid" [class.Is-Disabled]="NameFileCCP.invalid">
                </ng-autocomplete>

                <ng-template #itemTemplateReviewers let-item>
                  <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundReviewers let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Aprobador
              </div>
              <div class="Container-input Input-Autocomplete">
                <i class="fa-regular fa-user"></i>
                <ng-autocomplete #ngAutoCompleteApprovers [data]="ListOfUsersApprovers" [initialValue]=""
                  id="IdInputAuApNewCCP" placeholder="Buscar usuario aprobador" searchKeyword="Name"
                  formControlName="Approver" notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateApprovers"
                  [notFoundTemplate]="notFoundApprovers" [appFormCcpDisabled]="NameFileCCP.invalid"
                  [class.Is-Disabled]="NameFileCCP.invalid">
                </ng-autocomplete>

                <ng-template #itemTemplateApprovers let-item>
                  <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundApprovers let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Folio 4M
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-file-lines"></i><input id="IdinputInvoiceCCP" type="text"
                  formControlName="Invoice_4M" placeholder="Folio de 4M…" [class.Is-Disabled]="NameFileCCP.invalid"
                  [appFormCcpDisabled]="NameFileCCP.invalid">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                HOE Code
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-codepen"></i><input id="IdInputCodeNewCCP" type="text" formControlName="Code_CCP"
                  placeholder="Código HOE..." [class.Is-Disabled]="NameFileCCP.invalid"
                  [appFormCcpDisabled]="NameFileCCP.invalid">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                NO. Revisión
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-ellipsis"></i><input id="IdNoRevOne1NewCCP" type="text" formControlName="NoRevCCP"
                  placeholder="Numero de revisión…" [class.Is-Disabled]="NameFileCCP.invalid"
                  [appFormCcpDisabled]="NameFileCCP.invalid">
              </div>
            </div>


          </div>
          <div class="Container-Progress" id="Content-Progress">
            <div class="ProgressBar" id="Progress-Bar"></div>
          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" id="BtnSavedCCP">
              <i class="icon-send material-icons" id="Send-Icon">send</i>
              <i class="icon-check material-icons" id="Check-Icon">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn">Enviar HOE</span>
            </button>
            <button type="button" id="Btn-Close-Add-Bottom" (click)="ToggleModalAddCCP(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="Sweet-Alert" id="Sweet_Alert">
    <div class="Sweet-Alert--Icon">
      <div class="swal2-icon swal2-question swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">?</div>
      </div>
    </div>
    <div class="Sweet-Alert--Title">
      ¿Los datos son correctos?
    </div>
    <div class="Sweet-Alert--Text">
      Si todo esta bien, presiona el botón para continuar
    </div>
    <div class="Sweet-Alert--Container-Button">
      <button (click)="Sweet_Alert_Send_New_CCP()" class="Sweet-Alert--Container-Button--Button btn-icon-text">
        <i class="fa-solid fa-check-double"></i> <span>Sí, son correctos</span>
      </button>
      <button (click)="Toggle_Modal_Sweet_Alert_SendCCP(false)"
        class="Sweet-Alert--Container-Button--Button Cancel btn-icon-text">
        <span>Cancel</span>
      </button>
    </div>
  </div>
</section>

<!---===================== MODAL FOR UPDATE HOE =====================--->
<section class="Modal-Global" id="ModalUpdateCCP">
  <div class="wrapper">
    <div class="Pro-popupCCP1 popup">
      <div class="Pro-insideCCP1 popup-inside">
        <div class="Pro-backgroundsCCP1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormCCPUpdate" (ngSubmit)="ValidToogleCCPUpdate()">
        <div class="Pro-contentCCP1 content">
          <button type="button" id="Btn-Close-Update-Top" (click)="ToggleModalUpdateCCP(false)" class="Btn-Close"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Actualizar HOE</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input InputFile" id="IdInputFileNewCCPUpdate">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivo</div><input #UpdFileCCP (change)="UpdateAddDocument($event)"
                    type="file" name="">
                </div>
                <div class="Name-File">
                  {{CutNameFile(this.FileAuxUpdCCP.FileName)}}
                </div>
              </div>
            </div>

            <!-- <div class="Content-grid-2">
              <div class="Text-icon">
                Key Word
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-keycdn"></i><input id="IdInputKeyWNewCCPUpdate" type="text"
                  formControlName="KeyWord" placeholder="Key Word HOE..."
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid" [appFormCcpDisabled]="NameFileCCPUpdate.invalid">
              </div>
            </div> -->

            <div class="Content-grid-2">
              <div class="Text-icon">
                Model Year
              </div>
              <div class="Container-input Inputng-Select">
                <i class="fa-regular fa-circle-question"></i>
                <ng-select id="IdInputSeleNewCCPUpdate" class="Custom-Form" [searchable]="false"
                  [items]="OptionsModelYear" formControlName="Model_Year"
                  [appFormCcpDisabled]="NameFileCCPUpdate.invalid" [class.Is-Disabled]="NameFileCCPUpdate.invalid"
                  bindLabel="item" autofocus bindValue="value">
                </ng-select>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Shop
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputShopNewCCPUpdate" formControlName="Shop"
                  [appFormCcpDisabled]="NameFileCCPUpdate.invalid" [(ngModel)]="ShopSelected"
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid" [options]="Shops" optionLabel="Name"
                  placeholder="Seleccione una shop…"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Area
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputAreaNewCCPUpdate" formControlName="Area"
                  [appFormCcpDisabled]="NameFileCCPUpdate.invalid" [filter]="true"
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid" [options]="ShopSelected!?ShopSelected.Area:[]"
                  optionLabel="Name"
                  placeholder="{{ShopSelected!?'Seleccione una Area':'Seleccione primero una shop'}}"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Revisor
              </div>
              <div class="Container-input Input-Autocomplete">
                <i class="fa-regular fa-user"></i>
                <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="ListOfUsersReviewers"
                  id="IdInputAuReNewCCPUpdate" [initialValue]="" placeholder="Buscar usuario revisor"
                  searchKeyword="Name" notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateReviewers"
                  [notFoundTemplate]="notFoundReviewers" formControlName="Reviwer"
                  [appFormCcpDisabled]="NameFileCCPUpdate.invalid" [class.Is-Disabled]="NameFileCCPUpdate.invalid">
                </ng-autocomplete>

                <ng-template #itemTemplateReviewers let-item>
                  <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundReviewers let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Aprobador
              </div>
              <div class="Container-input Input-Autocomplete">
                <i class="fa-regular fa-user"></i>
                <ng-autocomplete #ngAutoCompleteApprovers [data]="ListOfUsersApprovers" [initialValue]=""
                  id="IdInputAuApNewCCPUpdate" placeholder="Buscar usuario aprobador" searchKeyword="Name"
                  formControlName="Approver" notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateApprovers"
                  [notFoundTemplate]="notFoundApprovers" [appFormCcpDisabled]="NameFileCCPUpdate.invalid"
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid">
                </ng-autocomplete>

                <ng-template #itemTemplateApprovers let-item>
                  <a [innerHTML]="item.Name"></a>
                </ng-template>

                <ng-template #notFoundApprovers let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Folio 4M
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-file-lines"></i><input id="IdinputInvoiceCCPUpdate" type="text"
                  formControlName="Invoice_4M" placeholder="Folio de 4M…"
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid" [appFormCcpDisabled]="NameFileCCPUpdate.invalid">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                HOE Code
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-codepen"></i><input id="IdInputCodeNewCCPUpdate" type="text"
                  formControlName="Code_CCP" placeholder="Código HOE..." [class.Is-Disabled]="NameFileCCPUpdate.invalid"
                  [appFormCcpDisabled]="NameFileCCPUpdate.invalid">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                NO. Revisión
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-ellipsis"></i><input id="IdNoRevOne1NewCCPUpdate" type="text"
                  formControlName="NoRevCCP" placeholder="Numero de revisión…"
                  [class.Is-Disabled]="NameFileCCPUpdate.invalid" [appFormCcpDisabled]="NameFileCCPUpdate.invalid">
              </div>
            </div>


          </div>
          <div class="Container-Progress" id="Content-Progress-Update">
            <div class="ProgressBar" id="Progress-Bar-Update"></div>
          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" id="Btn-Saved-Update">
              <i class="icon-send material-icons" id="Send-Icon">send</i>
              <i class="icon-check material-icons" id="Check-Icon">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn">Enviar HOE</span>
            </button>
            <button type="button" id="Btn-Close-Update-Bottom" (click)="ToggleModalUpdateCCP(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="Sweet-Alert" id="Sweet_Alert_Update">
    <div class="Sweet-Alert--Icon">
      <div class="swal2-icon swal2-question swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">?</div>
      </div>
    </div>
    <div class="Sweet-Alert--Title">
      ¿Los datos son correctos?
    </div>
    <div class="Sweet-Alert--Text">
      Si todo esta bien, presiona el botón para continuar
    </div>
    <div class="Sweet-Alert--Container-Button">
      <button (click)="Sweet_Alert_Send_New_CCP_Update()" class="Sweet-Alert--Container-Button--Button btn-icon-text">
        <i class="fa-solid fa-check-double"></i> <span>Sí, son correctos</span>
      </button>
      <button (click)="Toggle_Modal_Sweet_Alert_SendCCP_Update(false)"
        class="Sweet-Alert--Container-Button--Button Cancel btn-icon-text">
        <span>Cancel</span>
      </button>
    </div>
  </div>
</section>

<!---===================== MODAL FOR NOTIFICATION GROUPS HOE =====================--->
<section class="Modal-Global" id="ModalNotificationCCP">
  <div class="wrapper">
    <div class="Pro-popupNotCCP1 popup">
      <div class="Pro-insideNotCCP1 popup-inside">
        <div class="Pro-backgroundsNotCCP1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentNotCCP1 content">
        <div class="Btn-Close"></div>
        <div class="Content-Top">
          <h2>Notificar a grupos</h2>
        </div>

        <div class="Container-Body-Notification Content-body">

          <ng-container *ngIf="ShopSelected! && ShopSelected.ShopNotification.length>0 else Not_Groups">
            <div *ngFor="let group of ShopSelected.ShopNotification;let i = index" class="Container-Grid-Local Content-grid-2">
              <div class="Container-input Input-CheckBox">
                <input type="checkbox" id="CheckBox{{i}}" class="ui-checkbox">
              </div>
              <div class="Text-icon">
                {{group.Name}}
              </div>
            </div>
          </ng-container>

          <ng-template #Not_Groups>
            <div class="Not-Groups">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Mail_Groups.png" alt="">
              </div>
              <div class="Text-Not-Groups">
                No existen grupos de notificación para cargas de HOE.
              </div>
            </div>
          </ng-template>

        </div>
        <div class="Content-Bottom">
          <div (click)="SavedNewCCP()" class="Btn-LSave-Form Btn-Save-Modal">
            <i class="Icon-Two fa-regular fa-bell"></i>
            <span class="Btn-Save-Modal-text" id="Text-Btn">Guardar</span>
          </div>
          <button class="Btn-LCancel-Form Btn-Close-Modal" type="button" (click)="ToggleModalNotification(false)">
            <span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR NOTIFICATION GROUPS HOE UPDATE =====================--->
<section class="Modal-Global" id="ModalNotificationCCPUpdate">
  <div class="wrapper">
    <div class="Pro-popupNotCCP1 popup">
      <div class="Pro-insideNotCCP1 popup-inside">
        <div class="Pro-backgroundsNotCCP1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentNotCCP1 content">
        <div class="Btn-Close"></div>
        <div class="Content-Top">
          <h2>Notificar a grupos</h2>
        </div>

        <div class="Container-Body-Notification Content-body">


          <ng-container *ngIf="ShopSelected! && ShopSelected.ShopNotification.length>0 else Not_Groups">
            <div *ngFor="let group of ShopSelected.ShopNotification;let i = index" class="Container-Grid-Local Content-grid-2">
              <div class="Container-input Input-CheckBox">
                <input type="checkbox" id="CheckBoxUpdate{{i}}" class="ui-checkbox">
              </div>
              <div class="Text-icon">
                {{group.Name}}
              </div>
            </div>
          </ng-container>

          <ng-template #Not_Groups>
            <div class="Not-Groups">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Mail_Groups.png" alt="">
              </div>
              <div class="Text-Not-Groups">
                No existen grupos de notificación para cargas de HOE.
              </div>
            </div>
          </ng-template>

        </div>
        <div class="Content-Bottom">
          <div (click)="SavedUpdateCCP()" class="Btn-LSave-Form Btn-Save-Modal">
            <i class="Icon-Two fa-regular fa-bell"></i>
            <span class="Btn-Save-Modal-text" id="Text-Btn">Guardar</span>
          </div>
          <button class="Btn-LCancel-Form Btn-Close-Modal" type="button" (click)="ToggleModalNotificationUpdate(false)">
            <span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR PROPERTIES =====================--->
<section class="Modal-Global" id="ModalProperties">
  <div class="wrapper">
    <div class="Pro-popupCCP1 popup">
      <div class="Pro-insideCCP1 popup-inside">
        <div class="Pro-backgroundsCCP1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormCCPProperties" (ngSubmit)="SaveEditProperties()">
        <div class="Pro-contentCCP1 content">
          <div type="button" id="Btn-Close-Update-Top" (click)="ToggleModalProperties(false)" class="Btn-Close"><i
              class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Propiedades</h2>
            <h4>Modifica las propiedades de {{FCCP_Select_CM.Name}}</h4>
          </div>

          <div class="Content-body">

            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i><input id="IdInputFileCCPProperties" type="text"
                  formControlName="NameCCP" placeholder="Nombre HOE...">
              </div>
            </div>

            <!-- <div class="Content-grid-2">
              <div class="Text-icon">
                Key Word
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-keycdn"></i><input id="IdInputKeyWCCPProperties" type="text"
                  formControlName="KeyWord" placeholder="Key Word HOE...">
              </div>
            </div> -->

            <div class="Content-grid-2">
              <div class="Text-icon">
                Model Year
              </div>
              <div class="Container-input Inputng-Select">
                <i class="fa-regular fa-circle-question"></i>
                <ng-select id="IdInputSeleCCPProperties" class="Custom-Form" [searchable]="false"
                  [items]="OptionsModelYear" formControlName="Model_Year" bindLabel="item" autofocus bindValue="value">
                </ng-select>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Shop
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputShopNewCCPProperties" formControlName="Shop" [(ngModel)]="ShopSelected"
                  [options]="Shops" optionLabel="Name" placeholder="Seleccione una shop…"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Area
              </div>
              <div class="Container-input Inputng-Dropdown">
                <i class="fa-regular fa-circle-question"></i>
                <p-select id="IdinputAreaNewCCPProperties" formControlName="Area" [filter]="true"
                  [options]="ShopSelected!?ShopSelected.Area:[]" optionLabel="Name"
                  placeholder="{{ShopSelected!?'Seleccione una Area':'Seleccione primero una shop'}}"></p-select>
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Revisor
              </div>
              <ng-container *ngIf="CheckEditTask(FILE_CCP_Properties.TaskReviewer);else NotModifiedReviwer">
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="ListOfUsersReviewers"
                      id="IdInputAuReCCPProperties" [initialValue]="" placeholder="Buscar usuario revisor"
                      searchKeyword="Name" notFoundText="Usuario no encontrado" [itemTemplate]="itemTemplateReviewers"
                      [notFoundTemplate]="notFoundReviewers" formControlName="Reviwer">
                    </ng-autocomplete>

                    <ng-template #itemTemplateReviewers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundReviewers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)}}">
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==1"><i
                          class="fa-solid fa-user-pen"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==2"><i
                          class="fa-solid fa-user-clock"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==3"><i
                          class="fa-solid fa-user-check"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==4"><i
                          class="fa-solid fa-user-xmark"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==5"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==6"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==7"><i
                          class="fa-solid fa-users-slash"></i></div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NotModifiedReviwer>
                <div class="Container-input Propeties-Container" id="IdInputAuReCCPProperties">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{FILE_CCP_Properties.Reviewer_Name}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)}}">
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==1"><i
                          class="fa-solid fa-user-pen"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==2"><i
                          class="fa-solid fa-user-clock"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==3"><i
                          class="fa-solid fa-user-check"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==4"><i
                          class="fa-solid fa-user-xmark"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==5"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==6"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskReviewer)==7"><i
                          class="fa-solid fa-users-slash"></i></div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Aprobador
              </div>
              <ng-container *ngIf="CheckEditTask(FILE_CCP_Properties.TaskApprover);else NotModifiedApprover">
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete #ngAutoCompleteApprovers [data]="ListOfUsersApprovers" [initialValue]=""
                      id="IdInputAuApCCPProperties" placeholder="Buscar usuario aprobador" searchKeyword="Name"
                      formControlName="Approver" notFoundText="Usuario no encontrado"
                      [itemTemplate]="itemTemplateApprovers" [notFoundTemplate]="notFoundApprovers">
                    </ng-autocomplete>

                    <ng-template #itemTemplateApprovers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundApprovers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)}}">
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==1"><i
                          class="fa-solid fa-user-pen"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==2"><i
                          class="fa-solid fa-user-clock"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==3"><i
                          class="fa-solid fa-user-check"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==4"><i
                          class="fa-solid fa-user-xmark"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==5"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==6"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==7"><i
                          class="fa-solid fa-users-slash"></i></div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NotModifiedApprover>
                <div class="Container-input Propeties-Container" id="IdInputAuApCCPProperties">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{FILE_CCP_Properties.Approver_Name}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)}}">
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==1"><i
                          class="fa-solid fa-user-pen"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==2"><i
                          class="fa-solid fa-user-clock"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==3"><i
                          class="fa-solid fa-user-check"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==4"><i
                          class="fa-solid fa-user-xmark"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==5"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==6"><i
                          class="fa-solid fa-user-shield"></i></div>
                      <div *ngIf="Check_Status_Task_Icon(FILE_CCP_Properties.TaskApprover)==7"><i
                          class="fa-solid fa-users-slash"></i></div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Folio 4M
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-file-lines"></i><input id="IdinputInvoiceProperties" type="text"
                  formControlName="Invoice_4M" placeholder="Folio de 4M…">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                HOE Code
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-brands fa-codepen"></i><input id="IdInputCodeCCPProperties" type="text"
                  formControlName="Code_CCP" placeholder="Código HOE...">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                NO. Revisión
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-ellipsis"></i><input id="IdNoRevOne1CCPProperties" type="text"
                  formControlName="NoRevCCP" placeholder="Numero de revisión…">
              </div>
            </div>


          </div>

          <div class="Local-Content-Bottom Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-bookmark"></i><span class="text">Guardar</span>
            </button>
            <div id="Btn-Close-Update-Bottom" (click)="ToggleModalProperties(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR SAME FILES HOE =====================--->
<section class="Modal-Global" id="ModalSameFHCCP">
  <div class="Container-General-Duplicated" id="ModalSameFilesCCP">
    <div class="Top-Close"><a (click)="ToggleModalSameFilesCCP()" class="btn-cerrar-popup"><i
          class="fas fa-times"></i></a></div>
    <div class="Container-Duplicated">
      <div class="Header-Duplicated">
        <div class="Title">¡Importante!</div>
        <div class="Subtitle">HOE existente con el nombre
          '{{FileAuxUpdCCP.FileName===''?FileAuxAddCCP.FileName:FileAuxUpdCCP.FileName}}'
        </div>
      </div>
      <div class="body-Duplicated">
        <div class="Table">
          <table>
            <thead>
              <th class="on1">Ubicación</th>
              <th class="on2">Nombre</th>
            </thead>
            <tbody>
              <tr *ngFor="let file of FilesCCP_Dup">
                <td>
                  {{file.Route_Destination}}
                </td>
                <td>{{file.Name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="Fotter-Duplicated">
        <div (click)="ToggleModalSameFilesCCP()" class="Btn-OK">
          OK
        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR RENAME FILE OR DIRECTORY =====================--->
<section class="Modal-Global" id="ModalRenameFD">
  <div class="wrapper">
    <div class="Pro-popup3 popup">
      <div class="Pro-inside3 popup-inside">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormRenameFD" (ngSubmit)="RenameFD()">
        <div class="Pro-content3 content">
          <div class="Btn-Close" (click)="ToggleModalRename(false)"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2 *ngIf="this.FCCP_Select_CM.Directory">Renombrar Carpeta</h2>
            <h2 *ngIf="!this.FCCP_Select_CM.Directory">Renombrar HOE</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input Input-Text-Form" id="IdInputCodeNewCDMS">
                <i class="fa-solid fa-signature"></i><input type="text" formControlName="NameRename">
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-signature"></i><span class="text">Renombrar</span>
            </button>
            <div (click)="ToggleModalRename(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL CONTEXT MENU RIGHT CLICK =====================--->
<div class="Context-Menu" id="Context-Menu" (mouseleave)="Close_Context_Menu()">
  <ul>

    <li (click)="ToggleModalRename(true)" class="Item-Context"
      *ngIf="(UserRoleIn([PermissionCCP.renameFile]) && !FCCP_Select_CM.Directory) || (UserRoleIn([PermissionCCP.renameFolder]) && FCCP_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])">
      <i class="fa-regular fa-pen-to-square"></i>
      <span class="Text-Item">Renombrar</span>
    </li>

    <li (click)="EmitShowSidebar()" class="Item-Context"
      *ngIf="(UserRoleIn([PermissionCCP.moveFile]) && !FCCP_Select_CM.Directory) || (UserRoleIn([PermissionCCP.moveFolder]) && FCCP_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])">
      <i class="fa-solid fa-up-down-left-right"></i>
      <span class="Text-Item">Mover</span>
    </li>

    <li class="Item-Context List-Drop"
      *ngIf="(UserRoleIn([PermissionCCP.adminApprovation,PermissionCCP.adminRejection]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])) && !FCCP_Select_CM.Directory">
      <div><i class="fa-solid fa-clipboard-question"></i><span class="Text-Item">Flujo de HOE</span></div><i
        class="Drop fa-solid fa-angle-right"></i>
      <div>
        <ul>
          <li *ngIf="(UserRoleIn([PermissionCCP.adminApprovation]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP]))" (click)="Approve_CCP_For_Admin()" class="Item-Drop"><i class="fa-solid fa-check-double"></i><span
              class="Text-Item-Drop">Aprobar HOE</span>
          </li>
          <li *ngIf="(UserRoleIn([PermissionCCP.adminRejection]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP]))" (click)="Reject_CCP_For_Admin()" class="Item-Drop"><i class="fa-solid fa-xmark"></i><span
              class="Text-Item-Drop">Rechazar HOE</span></li>
        </ul>
      </div>
    </li>

    <li *ngIf="(UserRoleIn([PermissionCCP.versionHistory]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])) && !FCCP_Select_CM.Directory" (click)="See_version_History()" class="Item-Context">
      <i class="fa-solid fa-arrow-up-right-dots"></i>
      <span class="Text-Item">Historial de Versiones</span>
    </li>
    <li (click)="ToggleModalProperties(true)" class="Item-Context"
      *ngIf="(UserRoleIn([PermissionCCP.properties]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])) && !FCCP_Select_CM.Directory">
      <i class="fa-solid fa-file-pen"></i>
      <span class="Text-Item">Propiedades</span>
    </li>
    <li (click)="Delete_File_or_Directory()" class="Item-Context"
      *ngIf="(UserRoleIn([PermissionCCP.deleteFile]) && !FCCP_Select_CM.Directory) || (UserRoleIn([PermissionCCP.deleteFolder]) && FCCP_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorCCP])">
      <i class="fa-regular fa-trash-can"></i>
      <span class="Text-Item">Borrar</span>
    </li>



    <div class="separatorbar"></div>
    <li (click)="PreviewFile(FCCP_Select_CM); Close_Context_Menu()" class="Item-Context" *ngIf="!FCCP_Select_CM.Directory">
      <i class="fa-solid fa-eye"></i>
      <span class="Text-Item">Vista Previa</span>
    </li>

    <li (click)="this.SeeFolder_BreadCrum(this.NumberTopL)" class="Item-Context">
      <i class="fa-solid fa-arrows-rotate"></i>
      <span class="Text-Item">Recargar Pagina</span>
    </li>

    <li (click)="DownloadFile()" class="Item-Context" *ngIf="!FCCP_Select_CM.Directory">
      <i class="fa-solid fa-cloud-arrow-down"></i>
      <span class="Text-Item">Descargar</span>
    </li>

    <li (click)="Close_Context_Menu()" class="Item-Context"><i class="fa-solid fa-xmark"></i>
      <span class="Text-Item">Cerrar</span>
    </li>

  </ul>
</div>

<!---===================== MODAL FOR DOWNLOAD PROGRESS CIRCLE HOE =====================--->
<!-- <section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando HOE ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Content-Download-Table">
        <div class="outer">
          <div class="inner"></div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="160px" height="160px">
          <defs>
            <linearGradient id="GradientColor">
              <stop offset="0%" stop-color="#20a8e1" />
              <stop offset="100%" stop-color="#67c2ec" />
            </linearGradient>
          </defs>
          <circle cx="80" cy="80" r="77.5" stroke-linecap="round" id="Progress-circle" />
        </svg>
      </div>
    </div>
  </div>
</section> -->

<div class="background-Sidebar {{Right_Sidebar_Visible?'active':''}}">
  <p-drawer [(visible)]="Right_Sidebar_Visible" position="right" closeOnOutsideClick="true">
    <app-tree-move-proces-ccp (IsMoveCCP)="IsChangeEventCCP($event)" (ShowSideBar)="ShowSide($event)"
      [FCCP_Select_CM]="this.FCCP_Select_CM"></app-tree-move-proces-ccp>
  </p-drawer>
</div>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR HOE =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando HOE ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<!---===================== MODAL FOR REASON FOR REJECTION =====================--->
<section class="Modal-Global" id="ModalReject">
  <div class="wrapper">
    <div class="Pro-popup1 popup">
      <div class="Pro-inside1 popup-inside">
        <div class="Pro-backgrounds1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormReject" (ngSubmit)="SaveReject()">
        <div class="Pro-content1 content content_custom">
          <div (click)="ToggleModalReasonReject(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Rechazar HOE</h2>
            <h4>Escribe la razón de rechazo de la HOE</h4>
          </div>

          <div class="Content-body">
            <div class="Content-grid-1">
              <div class="Container-input Text-Area-Form">
                <i class="fa-solid fa-signature"></i><textarea id="IdTextAreaRejectCCP" formControlName="ReasonText"
                  placeholder="Razón de rechazo ..."></textarea>
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form1 btn-icon-text">
              <i class="fa-solid fa-location-arrow"></i><span class="text">Enviar</span>
            </button>
            <div (click)="ToggleModalReasonReject(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<app-document-viewer
  [visible]="showPreview"
  [fileName]="previewFileName"
  [fileUrl]="previewFileUrl"
  [extension]="previewFileExtension"
  (onClose)="showPreview = false"
  (onDownload)="DownloadFromPreview()">
</app-document-viewer>
